import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "btn", "input"]

  connect() {
  } // end connect

  view(e) {
    const show = e.currentTarget.dataset.viewType 
    const activeClass = "active"

    this.listTarget.classList.remove("list-view", "grid-view")
    this.listTarget.classList.add(show)

    this.btnTargets.forEach(btn => {
      btn.classList.toggle(activeClass, btn === e.currentTarget)
    })
  } // end view

  searchToggle(e) {
    e.preventDefault()
    
    if (this.hasInputTarget) {
      this.inputTarget.classList.toggle("show")
      if (this.inputTarget.classList.contains("show")) {
        this.inputTarget.focus()
      }
    }
  } // end searchToggle
}
